// extracted by mini-css-extract-plugin
module.exports = {"Personality":"personality-print_Personality__2jsau","Personality__h3":"personality-print_Personality__h3__2W3Jf","Personality__table":"personality-print_Personality__table__dX99W"};